/**
 * Re-export shared API utils and contract_review-specific base URL.
 */
import {
  getApiUrl,
  getApiHeaders,
  getApiAuthHeaders,
  throwIfAuthErrorResponse,
  apiFetch,
} from '../../../shared/utils/api';

export {
  getApiUrl,
  getApiHeaders,
  getApiAuthHeaders,
  throwIfAuthErrorResponse,
  apiFetch,
};

/** Base URL for contract review API (backend prefix /api/contracts). */
export const getContractApiBase = (): string => `${getApiUrl()}/api/contracts`;
